module.exports = __webpack_public_path__ + "db/cestlavie_style_ref.e65e408.csv";


//////////////////
// WEBPACK FOOTER
// ./src/db/cestlavie_style_ref.csv
// module id = ZslX
// module chunks = 2